
import { Athlete } from "@/types/team";
import axios from "axios";
import { defineComponent } from "vue";

export enum TeamAdminModalType {
  DELETE_ATHLETE = "DELETE_ATHLETE",
  PROMOTE_ADMIN = "PROMOTE_ADMIN",
  REVOKE_ADMIN = "REVOKE_ADMIN",
}

export default defineComponent({
  name: "TeamAdminModal",
  data() {
    return {
      TeamAdminModalType,
    };
  },
  props: {
    actionType: {
      type: String as () => TeamAdminModalType,
      required: true,
    },
    athlete: {
      type: Object as () => Athlete,
      required: true,
    },
    teamId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeTeamAdminModal");
    },
    async deleteAthlete(id: number) {
      const response = await axios.post(`/teams/${this.teamId}/removeMember`, {
        athleteId: id,
      });
      if (response.status !== 200) return this.$emit("openErrorModal");
      this.$emit("success");
      this.closeModal();
    },
    async promoteAthlete(id: number) {
      const response = await axios.post(`/teams/${this.teamId}/admin`, {
        athleteId: id,
      });
      if (response.status !== 200) return this.$emit("openErrorModal");
      this.$emit("success");
      this.closeModal();
    },
    async revokeAdmin(id: number) {
      const response = await axios.post(`/teams/${this.teamId}/removeAdmin`, {
        athleteId: id,
      });
      if (response.status !== 200) return this.$emit("openErrorModal");
      this.$emit("success");
      this.closeModal();
    },
  },
});
